import React from "react";
import './FormFloatingLabel.css'

function FormFloatingLabel({ label,style,required=false }) {
  return (
    <label title={label} style={ (style ? style : null) } className="form-floating-label">{label}{required && <span style={{color:"rgb(236 140 135)"}}> *</span>}</label>
  );
}
export default FormFloatingLabel;
